const pendingSavers = new Set();

export const registerPendingVisitSave = save => {
  pendingSavers.add(save);
  return () => pendingSavers.delete(save);
};

export const savePendingVisits = async () => {
  for (const save of [...pendingSavers]) await save();
};
